import { useRef, useState, useEffect } from 'react';
import QRCodeStyling from '@plasticprintersinc/pp-qr-code';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTypeHeaderIcon } from '../../../../utils/hooks/useTypeHeaderIcon'; 
import { useAuth } from '../../../../utils/Auth';
import styles from './Grid.module.css';

export default function Grid(props) {

    const { QR, total, childQRs } = props;

    const { userObj } = useAuth();
    const qrRef = useRef(null);
    const navigate = useNavigate();

    const { ref, inView } = useInView({
        root: null,
        rootMargin: '0px 0px -25px',
        threshold: .25
    });

    const { icon, header } = useTypeHeaderIcon(QR?.data?.qr_type);

    const options = QR?.data?.qr_style;
    const isBlurred = userObj?.plan?.plan_id === 0 && QR?.id.includes('-');
    const nickname = QR?.data?.nickname || QR?.nickname;
    const [ code, setCode ] = useState(inView ? new QRCodeStyling(options) : null);

    useEffect(() => {
        if (inView && !code && options) {
            setCode(() => new QRCodeStyling(options));
        } else if (inView && code && options) {
            code.update(options);
            code.append(qrRef.current);
        };
    },[inView, code, options, setCode]);

    const handleViewDetails = (tab) => {
        // is this correct url?
        navigate(`/collection/${QR.id}/details?tab=${tab}`);
    };

    return (
        <div className={styles.card} id={QR?.id} ref={ref}>
            <div className={styles.header} onClick={() => handleViewDetails('details')}>
                <OverlayTrigger
                    placement='top'
                    delay={{show: 250, hide: 400}}
                    trigger={['click','hover']}
                    overlay={<Tooltip>{nickname}</Tooltip>}
                >
                    <div className={styles.nickname} title={nickname}>{nickname}</div>
                </OverlayTrigger>
            </div>
            <div className={styles.codeWrap} onClick={() => handleViewDetails('details')}>
                {!code ? 
                    <div className={styles.qrLoad}><i className='fa-sharp fa-regular fa-qrcode' /></div>
                    :
                    <div 
                        className={isBlurred ? `${styles.code} ${styles.blur}` : styles.code} 
                        ref={qrRef}
                    />
                }
                {isBlurred && (
                    <div className={styles.band}>Sticker</div>
                )}
                <OverlayTrigger
                    placement='top'
                    delay={{show: 250, hide: 400}}
                    trigger={['click','hover']}
                    overlay={<Tooltip>{header}</Tooltip>}
                >
                    <div className={styles.qrType}><i className={icon} style={header === 'Link' ? {marginLeft: '.25rem'} : null} /></div>
                </OverlayTrigger>
            </div>
            <div className={styles.codeBtns} onClick={() => handleViewDetails('details')}>
                <OverlayTrigger
                    placement='top'
                    delay={{show: 250, hide: 400}}
                    trigger={['click','hover']}
                    overlay={<Tooltip>Total Scans include linked QR scans.</Tooltip>}
                >
                    <div className={styles.scanCount}>
                        <div><i className='fas fa-eye' />{total}</div>
                        <span>Views</span>
                    </div>
                </OverlayTrigger>
                <OverlayTrigger
                    placement='top'
                    delay={{show: 250, hide: 400}}
                    trigger={['click','hover']}
                    overlay={<Tooltip>View Linked QRs</Tooltip>}
                >
                    <button className={styles.childBtn} onClick={(e) => {e.stopPropagation(); handleViewDetails('linked');}}>
                        <div><i className='fa-regular fa-object-exclude' />{childQRs?.length}</div>
                        <span>Linked</span>
                    </button> 
                </OverlayTrigger>
            </div>
        </div>
    );
};